/**
 * captureDrawerMetrics — the ONE place the Captured drawer's footprint is
 * declared, so the drawer and the layout it pushes can never disagree.
 *
 * WHY IT EXISTS (measured live on web-stg, bundle main.378ce494.js, 2026-08-05,
 * headed Chromium at 1440x900, drawer opened with the real "Captured pane" rail
 * button):
 *
 *   drawer      <aside> fixed, x 1060 -> 1440, 380x900, z-index 1301
 *   save chip   [data-cy="autosave-chip"]  x 1177 -> 1340, y 19 -> 53
 *   side rail   SideMenuMainDiv            x 1360 -> 1440, 80x828
 *
 *   Both controls sit entirely inside the drawer's band.
 *   document.elementFromPoint() at the save chip's centre returned the drawer's
 *   <h2>, and a real Playwright click on the chip TIMED OUT after 8000ms.
 *   The user could not reach Save while the drawer was open.
 *
 * QA-67's directive is that this pane PUSHES content inward rather than covering
 * it. The push distance must be exactly the drawer's own width — if the two
 * numbers are ever edited apart, the bug returns silently as a partial overlap,
 * which is worse than the original because it looks fixed. Hence one constant,
 * imported by both.
 */

/** The drawer's width on any viewport wide enough for a rail-style drawer. */
export const CAPTURE_DRAWER_WIDTH_PX = 380;

/**
 * At or below this width the drawer goes full-bleed, so there is nothing left
 * to push content into: the push must switch OFF rather than collapse the page
 * to zero width. Same breakpoint the drawer's own `width: 100%` rule uses.
 */
export const CAPTURE_DRAWER_FULL_BLEED_MAX_PX = 480;
